import { baseUrl } from '../../network'

export const companySearchEmployeeFiltersUrl = (companyId: number)=> baseUrl + `/api/company/${companyId}/employees/filters`
export const companySearchEmployeesUrl = (companyId: number)=> baseUrl + `/api/company/${companyId}/employees`
